var map = {
	"./advertiser-media-types.json": 19084,
	"./advertiser-tags.json": 96553,
	"./available-communication-list.json": 79789,
	"./award-list.json": 30692,
	"./business-opportunity-list.json": 83357,
	"./client-types.json": 5591,
	"./company-growths.json": 18854,
	"./company-sizes.json": 89492,
	"./continents.json": 73641,
	"./countries.json": 12406,
	"./country-tags.json": 6192,
	"./customer_inquiry.json": 60866,
	"./departments.json": 53039,
	"./france-regions.json": 87559,
	"./hierarchical-levels.json": 64279,
	"./hobby-list.json": 14763,
	"./hobby-type-list.json": 63786,
	"./industry-classes.json": 2475,
	"./industry-types.json": 69018,
	"./job-classes.json": 94446,
	"./job-functions.json": 55967,
	"./job-types.json": 68459,
	"./leads-status-list.json": 6671,
	"./my-lists-types.json": 57562,
	"./news-tags.json": 96479,
	"./news-types.json": 12391,
	"./regional-leaders-list.json": 19181,
	"./school-type-list.json": 11210,
	"./sentence-types.json": 67573,
	"./shareholding-types.json": 9354,
	"./startup-techs.json": 14929,
	"./stock-market-indexes.json": 48744,
	"./structure-innovations.json": 63668,
	"./structure-types.json": 3261,
	"./tasks.json": 51118
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87379;